export const PERSIST_VALUES = 'PERSIST_VALUES';

export default {
    [PERSIST_VALUES]: (state, payload) => {
        state.persistedValues = payload;
    },
};
